import styled from "styled-components"
import { BreakPoints, media } from "../../helpers/rwd"
import {
  SectionWrapperStyles,
  NewContentStyles,
  NewsWrapperStyles,
  SectionNameStyles,
  NewLeftBlockStyles,
  NewRightBlockStyles,
  NewAssetWrapperStyles,
  NewAssetStyles,
  NewTitleBlockStyles,
  NewTitleStyles,
  NewGameNameStyles,
  NewGameDateStyled,
  NewDescriptionStyles,
  NewInformationBlockStyles,
  LoadMoreButtonStyles
} from "./horizontal-news-styles"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"

export const SectionWrapper = styled.div`
  background: #1F1630;
  display: flex;
  position: relative;
  width: 100%;
  min-height: 613px;

  ${media.max(BreakPoints.phone)} {
    min-height: 460px;
  }

  ${SectionWrapperStyles}
`

export const SectionName = styled.h3`
  font-weight: 500;

  ${media.max(BreakPoints.phone)} {
    margin: 31px 0 16px 8px;
  }

  ${SectionNameStyles};
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  display: flex;
  flex-direction: column;
  min-height: 400px;
  max-width: 1390px;
  z-index: 2;

  ${media.max(BreakPoints.lgDesktop)} {
    max-width: 1138px;
  }

  ${media.max(BreakPoints.desktop)} {
    max-width: 918px;
  }

`

export const NewsWrapper = styled.div`
  ${NewsWrapperStyles}
`

export const NewContent = styled.div`
  padding: 1px;
  display: flex;
  justify-content: space-between;
  max-width: 420px;
  ${NewContentStyles}
`

export const NewLeftBlock = styled.div`
  ${NewLeftBlockStyles}
`

export const NewRightBlock = styled.div`
  ${NewRightBlockStyles}
`

export const NewAssetWrapper = styled.div`
  ${NewAssetWrapperStyles}
`

export const NewAsset = styled.img`
  ${NewAssetStyles}
`

export const LoadMoreButton = styled.div`
  ${LoadMoreButtonStyles}
`

export const NewTitleBlock = styled.div`
  ${NewTitleBlockStyles}
`

export const NewTitle = styled.p`
  ${NewTitleStyles}
`

export const NewGameName = styled.p`
  ${NewGameNameStyles}
`

export const NewGameDate = styled.span`
  ${NewGameDateStyled}
`

export const NewDescription = styled.p`
  ${NewDescriptionStyles}
`

export const NewInformationBlock = styled.div`
  ${NewInformationBlockStyles}
`
